import { AWIN_MERCHANT_ID } from '@daymade/common-lib/affiliates';
import Script from 'next/script';

const AwinTag = () => (
  <Script
    id="awinMasterTag"
    src={`https://www.dwin1.com/${AWIN_MERCHANT_ID}.js`}
    defer
  />
);

export default AwinTag;
